import { render } from "./AddPickup.vue?vue&type=template&id=ff972474&scoped=true"
import script from "./AddPickup.vue?vue&type=script&lang=js"
export * from "./AddPickup.vue?vue&type=script&lang=js"

import "./AddPickup.vue?vue&type=style&index=0&id=ff972474&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff972474"]])

export default __exports__